var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-4 pa-4",staticStyle:{"background-color":"#fff","min-height":"calc(100vh - 100px)"}},[_c('h1',[_vm._v("Sidasi")])])
}]

export { render, staticRenderFns }